import { ALL_BID_STATUSES, BID_STATUS } from '../constants';

const NON_RESENDABLE_STATUSES = new Set([
	BID_STATUS.APPROVED,
	BID_STATUS.PENDING_DEPOSIT,
	BID_STATUS.DEPOSIT_PAID,
	BID_STATUS.REJECTED,
	BID_STATUS.PAID,
	BID_STATUS.WITHDRAWN,
	BID_STATUS.PENDING_PAYMENT,
]);

export const RESENDABLE_BID_STATUSES = new Set(
	ALL_BID_STATUSES.filter((status) => !NON_RESENDABLE_STATUSES.has(status)),
);

export const INVOICEABLE_BID_STATUSES = new Set([
	BID_STATUS.APPROVED,
	BID_STATUS.DEPOSIT_PAID,
	BID_STATUS.PENDING_PAYMENT,
]);

export const canResendProposal = (bid) =>
	Boolean(bid?.id) && RESENDABLE_BID_STATUSES.has(bid.status);

export const canSendInvoice = (bid) =>
	Boolean(bid?.id) && INVOICEABLE_BID_STATUSES.has(bid.status);

export const canResendDeposit = (bid) =>
	Boolean(bid?.id) &&
	bid.status === BID_STATUS.PENDING_DEPOSIT &&
	Boolean(bid.deposit_percent);

export const canResendInvoice = (bid) =>
	Boolean(bid?.capabilities?.can_resend_invoice);

export const canVoidInvoice = (bid) =>
	Boolean(bid?.capabilities?.can_void_invoice);

export const canCreateChangeOrder = (bid) => Boolean(bid?.sent_to_email);
